module.exports = __webpack_public_path__ + "img/project_e8.603e7b35.png";